import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get } from 'lodash-es';
import withLoader from '../../components/Loader/withLoader.js';
import constants from '../../constants.js';

// Actions
import {
  types as routingTypes,
  actions as routingActions,
} from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

// Components
import ArrangementDetailsLayout from './ArrangementDetailsLayout.js';
import ArrangementBalanceCard from './ArrangementBalanceCard/ArrangementBalanceCard.js';
import HelpCard from '../../components/HelpCard/HelpCard.js';
import ReplaceContact from '../../components/Replace/ReplaceContact/ReplaceContact';

import InfoIcon from '@material-ui/icons/InfoOutlined';

import { getString, stringToCamelCase } from '../../helpers/stringHelpers.js';
import { getLoadedStatus } from '../../helpers/loaderHelpers';
import { hasRole } from '../../helpers/authHelpers.js';
import analyticsApi from '../../api/analytics.js';

const stringsComponent = 'arrangements';

class ArrangementDetails extends React.Component {
  constructor(props) {
    super(props);

    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    const { setAppBarTitle, accountType, account } = this.props;

    setAppBarTitle(
      getString(
        stringsComponent,
        accountType == 'rent'
          ? 'RENT_ARRANGEMENTS_TITLE'
          : 'REPAIRS_ARRANGEMENTS_TITLE'
      )
    );

    this.checkShouldShow(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.checkShouldShow(nextProps);
  }

  shouldComponentUpdate(nextProps) {
    // Only rerender if not in a unloaded status.
    if (getLoadedStatus(this.getLoadedStatuses(nextProps)) !== 'UNLOADED') {
      return true;
    }
    return false;
  }

  getLoadedStatuses(props = this.props) {
    const { account, roles } = props;
    const loaded = [account.loaded];
    return loaded;
  }

  checkShouldShow(props) {
    const {
      account: { loaded, data },
      accountType,
      goAccounts,
    } = props;

    // If there is no arrangement data, direct back
    if (
      loaded === constants.LOADED &&
      !get(data, `accounts.${accountType}.arrangements[0]`, null)
    ) {
      goAccounts();
    }
  }

  goBack() {
    const {
      location: { prev },
      accountType,
      goAccounts,
      goAccountDetails,
    } = this.props;

    if (prev.type === routingTypes.ACCOUNT_DETAILS) {
      goAccountDetails(accountType);
    } else {
      goAccounts();
    }
  }

  render() {
    const {
      signout,
      account,
      appointments,
      inOutage,
      outageFrom,
      outageTo,
      outageMessage,
      accountType,
      goAccounts,
      toggleContactModal,
      onLoadComplete,
    } = this.props;

    const accountData = account.data;

    const WrappedArrangementDetailsLayout = withLoader(
      ArrangementDetailsLayout
    );

    const card = (
      <ArrangementBalanceCard
        data={get(accountData, `accounts.${accountType}.arrangements[0]`)}
      />
    );

    const help = portalGuidances.find(
      (guidance) =>
        guidance.Title === 'accounts_' + accountType + '_arrangements'
    ) && (
      <HelpCard
        title={getString('help', 'TITLE')}
        subheading={getString('help', 'SUBHEADING')}
        content={
          portalGuidances.find(
            (guidance) =>
              guidance.Title === 'accounts_' + accountType + '_arrangements'
          ).Content
        }
        contact={
          portalGuidances.find(
            (guidance) =>
              guidance.Title === 'accounts_' + accountType + '_arrangements'
          ).Contact
        }
        faqs={
          portalGuidances.find(
            (guidance) =>
              guidance.Title === 'accounts_' + accountType + '_arrangements'
          ).FAQs
        }
        icon={<InfoIcon />}
        toggleContactModal={toggleContactModal}
        gaEvent={analyticsApi.event}
      />
    );

    return (
      <WrappedArrangementDetailsLayout
        backAction={this.goBack}
        card={card}
        help={help}
        loaded={this.getLoadedStatuses()}
        onError={signout}
        inOutage={inOutage}
        outageFrom={outageFrom}
        outageTo={outageTo}
        outageMessage={
          outageMessage && (
            <ReplaceContact
              content={outageMessage}
              action={toggleContactModal}
              isLink={true}
            />
          )
        }
        failureText={
          <ReplaceContact
            content={portalContent.APP_ERROR_MESSAGE}
            action={toggleContactModal}
            isLink={true}
          />
        }
        notFoundText={
          <ReplaceContact
            content={portalContent.APP_NOT_FOUND_MESSAGE}
            action={toggleContactModal}
            isLink={true}
          />
        }
        onLoadComplete={onLoadComplete}
        title={getString(
          stringsComponent,
          accountType == 'rent'
            ? 'RENT_ARRANGEMENTS_TITLE'
            : 'REPAIRS_ARRANGEMENTS_TITLE'
        )}
        subtitle={getString(
          stringsComponent,
          (accountType == 'rent' ? 'RENT' : 'REPAIRS') + '_SUBTITLE'
        )}
        paymentReference={
          accountData.hasOwnProperty('accounts') &&
          accountData.accounts.hasOwnProperty(accountType)
            ? accountData.accounts[accountType].paymentReference
            : null
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  location: state.location,
  account: state.customer.account,
  appointments: state.customer.appointments,
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
  accountType: state.app.accountType,
  roles: state.auth.roles,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ArrangementDetails);
